import SingleShortcodeDocs from "./shortcodes/SingleShortCodeDocs"


type Props = {}

const SinglePrayerDoc = (props: Props) => {
  return (
    <div>
      <SingleShortcodeDocs />
    </div>
  )
}

export default SinglePrayerDoc